import { getUserStorageKey } from '#/features/storage/storage';
import { useWalletView } from '#/features/wallet/wallet-context';

export default function useUserStorageKey(key: string) {
  const walletView = useWalletView();
  const fullKey = getUserStorageKey(key, walletView.starknetAddress);
  return fullKey;
}
